<script lang="ts">
	import { getColorForUserName } from '$lib/svelte-utils/utils/colorUtils';

	export let name: string | null | undefined;
	export let imageUrl: string | null | undefined;
	export let showTitleOnHover = true;

	let clazz = '';
	export { clazz as class };

	let letters = '';

	$: {
		if (name && name?.length > 0) {
			if (name.length <= 2 && name.toUpperCase() === name) {
				letters = name;
				break $;
			}
			const split = name.replace(/\./, '').split(' ');
			letters = split[0][0].toUpperCase();
			if (split.length > 1) {
				letters += split[split.length - 1][0].toUpperCase();
			}
		}
	}
</script>

{#if name || imageUrl}
	{#if imageUrl}
		<img
			title={showTitleOnHover ? name : undefined}
			alt={letters ?? ''}
			class="{clazz || 'h-[36px] min-w-[36px]'} rounded-md"
			src={imageUrl}
		/>
	{:else if name}
		<div
			title={showTitleOnHover ? name : undefined}
			style:background-color={getColorForUserName(name)}
			class="flex items-center justify-center rounded-md p-2 text-white {clazz ||
				'h-[36px] w-[36px]'}"
		>
			<span>{letters}</span>
		</div>
	{/if}
{/if}
